import React, { useMemo, useState } from "react";
import Chip from "@mui/material/Chip";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { jsPDF } from "jspdf";
import { useMediaQuery } from "react-responsive";

const chipdata = [
  { nm: "Birth plan", id: "1", val: false },
  { nm: "Books & Magazine", id: "2", val: false },
  { nm: "breast pads", id: "3", val: false },
  { nm: "camera,batteries", id: "4", val: false },
  { nm: "contact lenscase", id: "5", val: false },
  { nm: "eyeglasses", id: "6", val: false },
  { nm: "dressing gown", id: "7", val: false },
  { nm: "ear plugs", id: "8", val: false },
  { nm: "facecloth", id: "9", val: false },
  { nm: "gift for older kid", id: "10", val: false },
  { nm: "facecloth", id: "11", val: false },
  { nm: "glucose tablets", id: "12", val: false },
  { nm: "Going home outfit", id: "13", val: false },
  { nm: "hairband", id: "14", val: false },
  { nm: "hairbrush", id: "15", val: false },
  { nm: "healthy snacks", id: "16", val: false },
  { nm: "hospital notes", id: "17", val: false },
  { nm: "heating pad", id: "18", val: false },
  { nm: "juice/water bottle", id: "19", val: false },
  { nm: "laundry bag", id: "20", val: false },
  { nm: "lip balm", id: "21", val: false },
  { nm: "make-up & remover", id: "22", val: false },
  { nm: "massage oil/lotion", id: "23", val: false },
  { nm: "grip socks", id: "24", val: false },
  { nm: "basic toiletries", id: "25", val: false },
  { nm: "thick sanitary-pads", id: "26", val: false },
  { nm: "massage tools", id: "27", val: false },
  { nm: "maternity pads", id: "28", val: false },
  { nm: "music,headphones", id: "29", val: false },
  { nm: "nursing bra", id: "30", val: false },
  { nm: "old/cheap underwear", id: "31", val: false },
  { nm: "pen and paper", id: "32", val: false },
  { nm: "playing card/puzzle", id: "33", val: false },
  { nm: "slippers", id: "34", val: false },
  { nm: "socks", id: "35", val: false },
  { nm: "pain relief machine", id: "36", val: false },
  { nm: "soap/scented bathgel", id: "37", val: false },
  { nm: "Socks", id: "38", val: false },
  { nm: "Myprega's web app", id: "39", val: false },
  { nm: "tissues", id: "40", val: false },
  { nm: "toothpaste,toothbrush", id: "41", val: false },
  { nm: "towels", id: "42", val: false },
  { nm: "two long t-shirts", id: "43", val: false },
  { nm: "video recorder", id: "44", val: false },
  { nm: "water spray", id: "45", val: false },
  { nm: "your own pillow", id: "46", val: false },
  { nm: "essential oils", id: "47", val: false },
];

const chipdata1 = [
  { nm: "3all-in-one outfits", id: "1", val: false },
  { nm: "3 muslin/burp cloths", id: "2", val: false },
  { nm: "blanket to wrap", id: "3", val: false },
  { nm: "car seat", id: "4", val: false },
  { nm: "cardigan", id: "5", val: false },
  { nm: "cotton balls", id: "6", val: false },
  { nm: "hat", id: "7", val: false },
  { nm: "jacket for winter", id: "8", val: false },
  { nm: "nappy diaper cream", id: "9", val: false },
  { nm: "newborn diapers", id: "10", val: false },
  { nm: "scratch mittens", id: "11", val: false },
  { nm: "socks or booties", id: "12", val: false },
  { nm: "soft brush", id: "13", val: false },
  { nm: "soft toy/chime", id: "14", val: false },
  { nm: "wash cloth", id: "15", val: false },
  { nm: "basic wipes", id: "16", val: false },
  { nm: "Medications", id: "17", val: false },
];

const chipdata2 = [
  { nm: "book,magazine", id: "1", val: false },
  { nm: "change of clothes", id: "2", val: false },
  { nm: "comfortable shoes", id: "3", val: false },
  { nm: "digital camera", id: "4", val: false },
  { nm: "list of phone numbers", id: "5", val: false },
  { nm: "loose change(parking/snacks)", id: "6", val: false },
  { nm: "music, headphones", id: "7", val: false },
  { nm: "paper & pencil/pen", id: "8", val: false },
  { nm: "snacks & drinks", id: "9", val: false },
  { nm: "toothpaste & toothbrush", id: "10", val: false },
  { nm: "Debit & Credit card", id: "11", val: false },
  { nm: "Some cash", id: "12", val: false },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Hospitalbag({ setExpand, setSelected }) {
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1023px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const [value, setValue] = useState(0);
  const [myList, setMyList] = useState(chipdata);
  const [myListbaby, setMyListbaby] = useState(chipdata1);
  const [myListpartner, setMyListpartner] = useState(chipdata2);
  const [save, setSave] = useState(false);
  const [save1, setSave1] = useState(false);
  const [save2, setSave2] = useState(false);

  const selectedMother = useMemo(
    () => myList.filter((item) => item.val),
    [myList]
  );
  const selectedBaby = useMemo(
    () => myListbaby.filter((item) => item.val),
    [myListbaby]
  );
  const selectedPartner = useMemo(
    () => myListpartner.filter((item) => item.val),
    [myListpartner]
  );

  const totalSelected =
    selectedMother.length + selectedBaby.length + selectedPartner.length;
  const canDownloadPdf = save && save1 && save2 && totalSelected > 0;

  const wrapper = {
    marginLeft: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    marginRight: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    paddingLeft: isMobile ? "12px" : isTabScreen ? "20px" : "30px",
    paddingRight: isMobile ? "12px" : "20px",
    paddingBottom: "28px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: "24px",
    marginBottom: "50px",
  };

  const sectionBox = {
    backgroundColor: "rgba(217, 217, 217, 0.2)",
    border: "1px solid #E3E3E5",
    borderRadius: "8px",
    padding: isMobile ? "12px" : "16px",
  };

  const chipGrid = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  };

  const chipItem = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const iconButton = {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "1px solid #D9D9D9",
    background: "#fff",
    color: "#E42346",
    fontWeight: 700,
    cursor: "pointer",
    lineHeight: "1",
  };

  const actionRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
    gap: "10px",
    flexWrap: "wrap",
  };

  const primaryButton = {
    minWidth: "113px",
    height: "36px",
    background: "#FFFFFF",
    border: "1px solid #E42346",
    borderRadius: "6px",
    color: "#E42346",
    fontWeight: 600,
    cursor: "pointer",
    padding: "0 14px",
  };

  const secondaryButton = {
    ...primaryButton,
    border: "1px solid #D9D9D9",
    color: "#333333",
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const toggleItem = (id, list, setList) => {
    const next = list.map((item) =>
      item.id === id ? { ...item, val: !item.val } : item
    );
    setList(next);
  };

  const clearList = (list, setList) => {
    setList(list.map((item) => ({ ...item, val: false })));
  };

  const downloadSelectedItemsPdf = () => {
    const doc = new jsPDF("p", "mm", "a4");
    const sections = [
      { title: "Mother", items: selectedMother },
      { title: "Baby", items: selectedBaby },
      { title: "Partner", items: selectedPartner },
    ];

    let y = 18;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Hospital Bag Checklist", 14, y);
    y += 8;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Print this PDF and tick each box after packing.", 14, y);
    y += 10;

    sections.forEach((section) => {
      if (y > 275) {
        doc.addPage();
        y = 18;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text(section.title, 14, y);
      y += 7;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);

      if (!section.items.length) {
        doc.text("No items selected.", 20, y);
        y += 8;
        return;
      }

      section.items.forEach((item) => {
        if (y > 285) {
          doc.addPage();
          y = 18;
        }
        doc.rect(20, y - 4.2, 4.2, 4.2);
        doc.text(item.nm, 28, y);
        y += 7;
      });

      y += 3;
    });

    doc.save("hospital-bag-checklist.pdf");
  };

  const renderSection = ({
    list,
    setList,
    isSaved,
    onSave,
    onEdit,
    onClear,
    selectedItems,
  }) => {
    return (
      <div style={sectionBox}>
        <div style={chipGrid}>
          {(isSaved ? selectedItems : list).map((item) => (
            <div key={item.id + item.nm} style={chipItem}>
              <Chip
                label={item.nm}
                variant="outlined"
                onClick={
                  isSaved ? undefined : () => toggleItem(item.id, list, setList)
                }
                style={{
                  color: item.val ? "#ffffff" : "#6B6D81",
                  backgroundColor: item.val ? "#E42346" : "#ffffff",
                  borderColor: "#000000",
                  fontSize: "11px",
                  height: "34px",
                  cursor: isSaved ? "default" : "pointer",
                }}
              />
              {!isSaved && (
                <button
                  type="button"
                  style={iconButton}
                  onClick={() => toggleItem(item.id, list, setList)}
                >
                  {item.val ? "-" : "+"}
                </button>
              )}
            </div>
          ))}
        </div>

        {!isSaved && selectedItems.length > 0 && (
          <div style={{ marginTop: "18px" }}>
            <button type="button" onClick={onSave} style={primaryButton}>
              SAVE
            </button>
          </div>
        )}

        {isSaved && (
          <div style={actionRow}>
            <span style={{ fontSize: "13px", color: "#333333" }}>
              Saved items: {selectedItems.length}
            </span>
            <div style={{ display: "flex", gap: "8px" }}>
              <button type="button" onClick={onEdit} style={secondaryButton}>
                Edit
              </button>
              <button type="button" onClick={onClear} style={secondaryButton}>
                Reset
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={wrapper}>
      <div
        style={{
          fontWeight: "600",
          fontSize: "18px",
          color: "#004AAD",
          cursor: "pointer",
        }}
        onClick={() => {
          setSelected(false);
          setExpand(true);
        }}
      >
        Back
      </div>

      <div
        style={{
          color: "#F0588B",
          fontWeight: "600",
          fontSize: isMobile ? "20px" : "24px",
          paddingTop: "10px",
        }}
      >
        Hospital Bag
      </div>

      <div
        style={{
          paddingTop: "18px",
          fontWeight: "400",
          fontSize: isMobile ? "16px" : "18px",
          color: "#333333",
          lineHeight: 1.5,
        }}
      >
        Just about 5 percent Trusted Source of babies are born on their actual
        due date. In reality, your baby may come a couple weeks before or after
        when you&apos;re expecting. Consider packing your bags at least 3 weeks
        before your due date. This gives you a bit of time for the unexpected.
      </div>

      <div style={{ paddingTop: "26px" }}>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="hospital bag tabs"
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#F0588B",
                },
              }}
            >
              <Tab label="MOTHER" {...a11yProps(0)} />
              <Tab label="BABY" {...a11yProps(1)} />
              <Tab label="PARTNER" {...a11yProps(2)} />
            </Tabs>
          </Box>

          <TabPanel value={value} index={0}>
            {renderSection({
              list: myList,
              setList: setMyList,
              isSaved: save,
              onSave: () => setSave(true),
              onEdit: () => setSave(false),
              onClear: () => {
                clearList(myList, setMyList);
                setSave(false);
              },
              selectedItems: selectedMother,
            })}
          </TabPanel>

          <TabPanel value={value} index={1}>
            {renderSection({
              list: myListbaby,
              setList: setMyListbaby,
              isSaved: save1,
              onSave: () => setSave1(true),
              onEdit: () => setSave1(false),
              onClear: () => {
                clearList(myListbaby, setMyListbaby);
                setSave1(false);
              },
              selectedItems: selectedBaby,
            })}
          </TabPanel>

          <TabPanel value={value} index={2}>
            {renderSection({
              list: myListpartner,
              setList: setMyListpartner,
              isSaved: save2,
              onSave: () => setSave2(true),
              onEdit: () => setSave2(false),
              onClear: () => {
                clearList(myListpartner, setMyListpartner);
                setSave2(false);
              },
              selectedItems: selectedPartner,
            })}
          </TabPanel>
        </Box>
      </div>

      {canDownloadPdf && (
        <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={downloadSelectedItemsPdf}
            style={{
              ...primaryButton,
              background: "#E42346",
              color: "#FFFFFF",
              border: "1px solid #E42346",
              minWidth: "185px",
            }}
          >
            Download PDF Checklist
          </button>
        </div>
      )}
    </div>
  );
}

export default Hospitalbag;
